import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { GlobalAppDataStorageService } from "infra/storage";
import { Controller, useFormContext } from "react-hook-form";

export default function Personality({ data }) {
    const {
        control,
    } = useFormContext();
    
    const softSkillsOptions = GlobalAppDataStorageService.getSoftSkills();
    const motivationOptions = GlobalAppDataStorageService.getMotivations();
    const attitudeOptions = GlobalAppDataStorageService.getAttitudes();
    
    return (
        <Box component="section" sx={{ mb: 4, width: "100%", display: "grid", gap: 2, gridTemplateColumns: "repeat(4, 1fr)" }}>
            <Typography variant="h6" gutterBottom sx={{ gridColumn: "span 4" }}>
                Personality
            </Typography>
            <Controller
                name="personality.attitude"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="personality.attitude_id"
                        autoComplete
                        limitTags={1}
                        fullWidth
                        options={attitudeOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(event, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Attitude"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <Controller
                name="personality.motivations"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="personality.motivations"
                        autoComplete
                        multiple
                        limitTags={1}
                        fullWidth
                        options={motivationOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(event, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Motivations"
                                sx={{
                                    gridColumn: { xs: "span 4", sm: "span 2" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: { xs: "span 4", sm: "span 2" },
                        }}
                    />
                )}
            />
            <Controller
                name="personality.softSkills"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                        id="personality.softSkills"
                        autoComplete
                        multiple
                        limitTags={1}
                        fullWidth
                        options={softSkillsOptions || []}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(option, value) =>
                            option?.name === value?.name
                        }
                        {...field}
                        onChange={(event, newValue) => {
                            field.onChange(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Soft Skills"
                                sx={{
                                    gridColumn: "span 4",
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        )}
                        sx={{
                            gridColumn: "span 4",
                        }}
                    />
                )}
            />
        </Box>
    );
}
